import { FormattedMessage, useIntl } from "react-intl";
import { Spinner } from "components";
import clsx from "clsx";
import { useState, useEffect } from "react";

import { EditIcon } from "./EditIcon";

type IRemarkProsp = {
  isLoading?: boolean;
  remark: string;
  isShow?: boolean;
  isEdit?: boolean;
  onSubmit: (remark: string) => void;
  onToggleEdit: () => void;
};

export const Remark: React.FC<IRemarkProsp> = ({
  isLoading,
  remark,
  isEdit,
  isShow,
  onSubmit,
  onToggleEdit,
}) => {
  const { formatMessage } = useIntl();

  const [value, setValue] = useState<string>("");

  const onClick = () => {
    onSubmit(value);
  };

  useEffect(() => {
    if (isEdit) setValue(remark);
    else {
      setValue("");
    }
  }, [remark, isEdit]);

  return (
    <div>
      <div className="pt-[50px] pb-[40px]">
        <div
          className="flex flex-row items-end gap-1 w-fit mb-[6px]"
          onClick={onToggleEdit}
        >
          <span className="text-black333 dark:text-white">
            <EditIcon />
          </span>

          <span className="text-xs leading-[18px]">
            <FormattedMessage id="meter.detail.remarks" />
          </span>
        </div>
        {!isEdit && <p>{remark}</p>}
        {isEdit && (
          <>
            <textarea
              defaultValue={remark}
              className="border border-solid border-[#C0C2C5] rounded-[5px] bg-transparent h-[111px] box-border py-3 px-[14px] w-full outline-none focus-within:border-primary"
              //   placeholder-style="font-size: 14px;color:#C4C4C4;font-family:Roboto;"
              placeholder={formatMessage({
                id: "meter.detail.remarkPlaceHolder",
              })}
              onChange={(e) => setValue(e.target.value)}
            ></textarea>
            <div className="flex flex-row justify-end">
              <div
                onClick={onClick}
                className={clsx(
                  "w-[102px] h-[36px] rounded-lg text-sm text-white flex flex-row items-center justify-center mt-[7px]",
                  {
                    "bg-primary": value,
                    "bg-[#C0C2C5]": isLoading || !value,
                    "cursor-pointer": !isLoading,
                  }
                )}
              >
                {isLoading ? (
                  <Spinner extraSmall className={{ "border-white": true }} />
                ) : (
                  <FormattedMessage id="meter.detail.addRemark" />
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div
        className={clsx(
          "w-full fixed bottom-0 left-[50%] -translate-x-1/2 flex flex-row items-center justify-center h-0"
        )}
      >
        <div
          className={clsx(
            "w-fit opacity-0 py-[11px] px-[15px] text-[#909192] rounded-[5px] text-sm dark:bg-black333 dark:text-white80 bg-white shadow-[0px_51px_14px_0px_rgba(112,112,112,0.00),0px_33px_13px_0px_rgba(112,112,112,0.01),0px_18px_11px_0px_rgba(112,112,112,0.05),0px_8px_8px_0px_rgba(112,112,112,0.09),0px_2px_4px_0px_rgba(112,112,112,0.10)]",
            {
              "animate-slide-up": isShow,
            }
          )}
        >
          <FormattedMessage id="meter.detail.addRemarkSuccessfully" />
        </div>
      </div>
    </div>
  );
};
